// Mixin to invoke `onUserChanged()` method in components if defined when user logged in as a different user (even from the dummy guest user)
// onUserChanged() should be implemented on pages which require reloading data when user identity changes

export default {
  data() {
    return {
      loadedAt: 1,
    };
  },

  computed: {
    loggedInAt() {
      return this.$store && this.$store.state.currentUser.loggedInAt;
    },
  },

  watch: {
    loggedInAt: function(newLoggedInAt, oldLoggedInAt) {
      if (this.loadedAt + 1000 >= this.newLoggedInAt) { return; } // allow 1 sec of error
      this.loadedAt = window.Date.now();
      if (this.onUserChanged) { this.onUserChanged(); }
    }
  },

  mounted() {
    this.loadedAt = window.Date.now();
  },
};
